import { Component, Input } from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'input-validators',
    templateUrl: './input-validators.component.html',
    styleUrls: ['./input-validators.component.scss']
})

export class InputValidatorsComponent {
    @Input() controlName: String = '';
    @Input() controlParent?: String = '';
    @Input() control: FormControl = null;
}
